// src/components/landing/OwnerCTA.tsx
import React from "react";
import { ArrowRight } from "lucide-react";

export function OwnerCTA() {
  return (
    <section id="for-owners" className="mx-auto max-w-7xl px-5 pb-20 sm:px-8">
      <div className="relative overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-br from-[#0F172A] to-[#1D3A6B] p-8 sm:p-12">
        <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-[#EB4A2D]/25 blur-3xl" />
        <div className="relative flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between">
          <div className="max-w-lg">
            <h2 className="font-display text-2xl text-white sm:text-3xl">Own a hoarding, screen or mall unit?</h2>
            <p className="mt-3 text-sm text-white/70">
              List your space on Adroj and get discovered by brands actively searching by your city and category.
            </p>
          </div>
          <a
            href="#top"
            className="flex shrink-0 items-center gap-2 rounded-full bg-white px-5 py-3 text-sm font-semibold text-[#0F172A] transition-transform hover:scale-[1.03]"
          >
            List your space <ArrowRight className="h-4 w-4" />
          </a>
        </div>
      </div>
    </section>
  );
}